import ApiService from './ApiService';

export default class ReservationApi extends ApiService {
    constructor() {
        super('');
    }

    // #region CMS
    getReservationCMSList(payload) {
        return this.get('system/reservations', payload);
    }

    getReservationCMSDetail(payload) {
        return this.get(`system/reservations/${payload.id}`);
    }

    cancelReservationCMS(payload) {
        return this.put('system/reservations/management-cancel', payload);
    }

    updateReservationCMS(payload) {
        const { id, ...data } = payload;
        return this.put(`system/reservations/update/${id}`, data);
    }

    updateReservationStatusCMS(payload) {
        const { id, ...data } = payload;
        return this.put(`system/reservations/update-status/${id}`, data);
    }

    getTransactionHistory(payload) {
        const { id, ...data } = payload;
        return this.get(`system/reservations/transaction-history/${id}`, data);
    }

    // #region Report Bike
    getReportBikeDetail(payload) {
        return this.get(`system/reservations/infor/${payload.id}`);
    }

    postReportBike(payload) {
        const { id, ...data } = payload;
        return this.post(`system/reservations/report-bike/${id}`, data);
    }

    getReservationsReportHistory(id) {
        return this.get(`reservations/report-history/${id}`);
    }

    getReservationsReturnHistory(id) {
        return this.get(`reservations/return-history/${id}`);
    }

    // #region Update Booking
    confirmUpdateBooking(payload) {
        const { id, ...data } = payload;
        return this.post(`system/reservations/confirm-infor/${id}`, data);
    }

    updateBookingInfor(payload) {
        const { orderId, ...data } = payload;
        return this.put(`system/reservations/update-infor/${orderId}`, data);
    }

    requestAdditionalPayment(payload) {
        const { orderId, ...data } = payload;
        return this.post(`system/reservations/request-additional-payment/${orderId}`, data);
    }

    cancelAdditionalPayment(payload) {
        const { paymentId, ...data } = payload;
        return this.put(`system/reservations/payment/${paymentId}/cancel`, data);
    }

    // #region Enduser

    getReservationENDList(payload) {
        return this.get('customer/reservations', payload);
    }

    getReservationENDDetail(id) {
        return this.get(`customer/reservations/${id}`);
    }

    rePayment(id) {
        return this.post(`customer/orders/re-payment/${id}`);
    }

    cancelReservationEND(payload) {
        const { id, note } = payload;
        return this.post(`customer/orders/cancel/${id}`, { note });
    }

    requestUpdateBooking(payload) {
        const { id, note } = payload;
        return this.post(`customer/orders/request-change-infor-order/${id}`, { note });
    }

    // #region General
    downloadFileInvocie(payload) {
        const { id, ...otherPayload } = payload;

        return this.get(`files/pdf/invoice/${id}`, otherPayload, { responseType: 'blob' });
    }

    downloadFileReceipt(payload) {
        const { id, ...otherPayload } = payload;

        return this.get(`files/pdf/receipt/${id}`, otherPayload, { responseType: 'blob' });
    }

    getAllPaymentHistoryByOrder(payload) {
        return this.get(`reservations/payment-history/${payload.id}`);
    }
}
